import { Auth } from "aws-amplify";
import { APP_CONFIG } from "../AppConfig";
export class BaseService {
  async fetchData(path, method = "GET", body = null) {
    const response = await fetch(`${path}`, {
      method: method,
      headers: await this.getHeaders(),
      body: body,
    });
    const data = await response.json();
    return data;
  }

  async getHeaders() {
    const session = await Auth.currentSession();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      "X-API-KEY": APP_CONFIG.CUST_PORTAL_API_KEY,
    };
    return headers;
  }
}
